import React from 'react';
import RenderIf from '../render-if/Renderif';
import { DEMAND } from "../../utils/enum";
import { useDownloadDemandDraft } from "../../hooks/useDownloadDemandDraft";
import CancelButton from "./CancelButton";
import Tabs from "./tabs";
import MedicalRecordDetails from "./MedicalRecordDetails";

const MedicalViewSummaryModal = ({
    proccessedMedicalRecordsStored,
    isOpenProcessedMedicalRecordsModal,
    closeMedicalSummaryRecordModel,
    plainTiffs,
    caseId,
    selectedTiffIndex,
    setSelectedTiffIndex,
}) => {
    const downloadDemandDraft = useDownloadDemandDraft();

    const getMedicalBillData = (medicalBillData = []) => {

        const billMap = new Map();
        let totalAmount = 0;
        for (const bill of medicalBillData) {
            const medicalProviderName = bill?.medicalProviderName.split('_')[0];
            const totalBillAmount = bill?.totalBillAmount > 0 ? parseFloat(bill.totalBillAmount) : 0;

            if (billMap.has(medicalProviderName)) {
                billMap.set(medicalProviderName, billMap.get(medicalProviderName) + totalBillAmount);
            } else {
                billMap.set(medicalProviderName, totalBillAmount);
            }

            totalAmount += totalBillAmount;
        }

        const billPerProvider = [];
        billMap.forEach((totalBillAmount, medicalProviderName) => {
            billPerProvider.push({ medicalProviderName, totalBillAmount });
        });

        return billPerProvider
    };

    const filterClientsMedicalData = proccessedMedicalRecordsStored?.medicalProcessedData?.find(
        (client) => client.clientId === plainTiffs[selectedTiffIndex]?.clientId
    )
    const groupedBillData = getMedicalBillData(filterClientsMedicalData?.medicalBillRecords)

    return (
        <>
            {isOpenProcessedMedicalRecordsModal && <div className="modal upload-template-modal medical-records show d-block" tabIndex="-1">
                <div className="modal-dialog modal-dialog-scrollable" >
                    <div className="modal-content" >
                        <div className="modal-header">
                            <h5 className="modal-title">Medical Summary</h5>
                            <CancelButton isButton={false} onClose={closeMedicalSummaryRecordModel} />
                        </div>
                        
                        <Tabs
                            tabList={plainTiffs}
                            selectedTabIndex={selectedTiffIndex}
                            onTabChange={setSelectedTiffIndex}
                            isModalTab={true}
                        />
                        <div className="modal-body modal-scroll">
                            <div className="row" style={{backgroundColor:'#E9F1F9'}}>
                                <RenderIf shouldRender={filterClientsMedicalData?.preMedicalRecords?.length}>
                                    <div className="col-md-12">
                                        <h6 className="pre-medical-header-text mb-2 mt-3">Pre-Accident Medical Records</h6>
                                        {filterClientsMedicalData?.preMedicalRecords?.map((data, index) => (
                                            <div key={index} className="modal-box-style mt-3">
                                                <MedicalRecordDetails data={data} />
                                            </div>
                                        ))}
                                    </div>
                                </RenderIf>
                                <RenderIf shouldRender={filterClientsMedicalData?.medicalRecords?.length}>
                                    <div className="col-md-12">
                                        <h6 className="pre-medical-header-text mb-2 mt-3">Post-Accident Medical Records</h6>
                                        {filterClientsMedicalData?.medicalRecords?.map((data, index) => (
                                            <div key={index} className="modal-box-style mt-3">
                                                <MedicalRecordDetails data={data} />
                                            </div>
                                        ))}
                                    </div>
                                </RenderIf>
                                <RenderIf shouldRender={groupedBillData?.length}>
                                    <div className="col-md-12 mt-4 mb-10">
                                        <h6 className="pre-medical-header-text mb-2">Medical Bill Records</h6>
                                        <div className="modal-scroll"
                                        >
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr className="provider-title">
                                                        <th style={{color:'black'}}>S.No</th>
                                                        <th style={{color:'black'}}>Medical Provider Name</th>
                                                        <th style={{ textAlign: "right" ,color:'black' }}>
                                                            Total Bill Amount
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {groupedBillData?.map((data, index) => (
                                                        <tr key={index} style={{backgroundColor:'white'}}>
                                                            <td>{index + 1}</td>
                                                            <td>{data.medicalProviderName}</td>
                                                            <td style={{ textAlign: "right" }}>{data.totalBillAmount}</td>

                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </RenderIf>
                            </div>
                            <div className="modal-footer">
                                <CancelButton isButton={true} onClose={closeMedicalSummaryRecordModel} />
                                <button type="button" onClick={() => { downloadDemandDraft({ caseId, caseName: '', typeOfDemandDraft: DEMAND.Medical_Chronology }) }} className="btn btn-theme">
                                    Download
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
        </>
    )
}

export default MedicalViewSummaryModal;